import { render } from "./minimum.vue?vue&type=template&id=1ea4cb87"
import script from "./minimum.vue?vue&type=script&lang=js"
export * from "./minimum.vue?vue&type=script&lang=js"

import "./minimum.vue?vue&type=style&index=0&id=1ea4cb87&lang=css"

import exportComponent from "/var/www/html/resources/sellers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__